module.exports = __webpack_public_path__ + "img/5.b80dd6b2.svg";